<!--
 * @Description: 质检记录弹框
 * @Author: ChenXueLin
 * @Date: 2023-03-09 16:29:31
 * @LastEditTime: 2023-03-10 16:29:47
 * @LastEditors: ChenXueLin
-->
<template>
  <div :class="[recordVisible ? 'dialogMask' : 'hiddenMask']">
    <el-dialog
      title="质检记录"
      :visible.sync="recordVisible"
      :close-on-click-modal="false"
      width="1400px"
      v-loading="dialogLoading"
      :element-loading-background="loadingBackground"
      custom-class="audit-dialog"
      :before-close="closeDialog"
      @open="openDialog"
      :modal-append-to-body="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        v-if="type == 'maintenQualityInspection'"
      >
        <el-table
          :data="formData.tableData"
          border
          highlight-current-row
          class="inspectionRecordTable"
        >
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="主体"
            prop="mainBodyId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.mainBodyId`"
                :rules="[{ required: true, message: '请选择主体' }]"
              >
                <e6-vr-select
                  v-model="scope.row.mainBodyId"
                  :data="mainBodyIdList"
                  placeholder="主体"
                  title="主体"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="
                    (val, node) => {
                      changeMainbodyId(val, node, scope.$index);
                    }
                  "
                  @clear="
                    () => {
                      clearMainbodyId(scope.$index);
                    }
                  "
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="故障现象"
            prop="quesReasonId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.quesReasonId`"
                :rules="[{ required: true, message: '请选择故障现象' }]"
              >
                <e6-vr-select
                  v-model="scope.row.quesReasonId"
                  :data="scope.row.quesReasonList"
                  placeholder="故障现象"
                  title="故障现象"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeQuesReasonId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="故障归类"
            prop="failPointId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.failPointId`"
                :rules="[{ required: true, message: '请选择故障归类' }]"
              >
                <e6-vr-select
                  v-model="scope.row.failPointId"
                  :data="scope.row.failPointList"
                  placeholder="故障归类"
                  title="故障归类"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeFailPointId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="处理措施"
            prop="solutionId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.solutionId`"
                :rules="[{ required: true, message: '请选择处理措施' }]"
              >
                <e6-vr-select
                  v-model="scope.row.solutionId"
                  :data="scope.row.solutionList"
                  placeholder="处理措施"
                  title="处理措施"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeSolutionId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="故障原因"
            prop="faultReasonId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.faultReasonId`"
                :rules="[{ required: true, message: '请选择故障原因' }]"
              >
                <e6-vr-select
                  v-model="scope.row.faultReasonId"
                  :data="scope.row.faultReasonList"
                  placeholder="故障原因"
                  title="故障原因"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeFaultReasonId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            header-align="center"
            label="责任主体"
            prop="responsibleEntityId"
            width="230"
          >
            <template v-slot="scope">
              <el-form-item
                :prop="`tableData.${scope.$index}.responsibleEntityId`"
                :rules="[{ required: true, message: '请选择责任主体' }]"
              >
                <e6-vr-select
                  v-model="scope.row.responsibleEntityId"
                  :data="scope.row.responsibleEntityList"
                  placeholder="责任主体"
                  title="责任主体"
                  clearable
                  virtual
                  :props="{
                    id: 'faultClassId',
                    label: 'faultName'
                  }"
                  @change="(val, node) => changeResponsibleEntityId(val, node, scope.$index)"
                  :is-title="true"
                ></e6-vr-select>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <el-form label-width="100px" :model="submitForm" ref="submitForm">
        <el-form-item label="是否工艺纠正" prop="isProcessCorrection">
          <el-switch
            v-model="submitForm.isProcessCorrection"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="纠正内容" prop="processCorrection">
          <el-input
            placeholder="请输入纠正内容"
            v-model="submitForm.processCorrection"
            maxlength="200"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="异常纠正类型" prop="correctiveActionCode">
          <e6-vr-select
            v-model="submitForm.correctiveActionCode"
            :data="correctiveActionCodeList"
            placeholder="异常纠正类型"
            title="异常纠正类型"
            clearable
            :props="{
              id: 'codeId',
              label: 'codeName'
            }"
            virtual
            multiple
            :is-title="true"
          ></e6-vr-select>
        </el-form-item>
        <el-form-item label="上传质检凭证" prop="fileIdList">
          <uploadOBS
            class="avatar-uploader"
            v-model="submitForm.fileIdList"
            :fileType="2"
            :limit="5"
            showFileList
            multiple
            showBtnType="0"
            :uploadFileList.sync="submitForm.fileList"
            isShowIcon
            :limitConfig="['jpeg', 'png', 'bmp', 'gif', 'jpg']"
          >
          </uploadOBS>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button class="cancel" @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import base from "@/mixins/base";
import uploadOBS from "@/components/uploadOBS/uploadOBS";
import { printError } from "@/utils/util";
import {
  findDownList,
  getFaultClassByParent,
  saveInspectionRecord,
  queryInspectionRecord
} from "@/api";
export default {
  name: "inspectionRecordDialog",
  components: { uploadOBS },
  data() {
    return {
      responsibilityCodeList: [],
      correctiveActionCodeList: [],
      mainBodyIdList: [],
      dialogLoading: false,
      formData: {
        tableData: [
          {
            mainBodyId: "",
            failPointId: "",
            responsibilityCode: "",
            quesReasonList: [],
            failPointList: [],
            solutionList: [],
            faultReasonList: [],
            responsibleEntityList: [],
            responsibleConfirm: ""
          }
        ]
      },
      submitForm: {
        isProcessCorrection: 0,
        inspectionRecordId: "",
        processCorrection: "",
        correctiveActionCode: [],
        fileIdList: [],
        fileList: []
      }
    };
  },
  mixins: [base],
  props: {
    recordVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    taskInspectionId: {
      type: [Number, String],
      default: ""
    }
  },

  computed: {},
  watch: {},
  methods: {
    // 规范化选项结构，确保包含 faultClassId / faultName 字段
    normalizeOptions(list) {
      if (!Array.isArray(list)) return [];
      return list.map(item => ({
        ...item,
        faultClassId: item.faultClassId != null ? item.faultClassId : (item.id != null ? item.id : item.codeId),
        faultName: item.faultName != null ? item.faultName : (item.name != null ? item.name : (item.codeName != null ? item.codeName : ''))
      }));
    },
    // 统一将可能为 null 的值置为组件可接受的类型（字符串/数组）
    sanitizeRow(row) {
      const toStrOrEmpty = v => (v === undefined || v === null ? '' : v);
      return {
        ...row,
        mainBodyId: toStrOrEmpty(row.mainBodyId),
        quesReasonId: toStrOrEmpty(row.quesReasonId),
        failPointId: toStrOrEmpty(row.failPointId),
        solutionId: toStrOrEmpty(row.solutionId),
        faultReasonId: toStrOrEmpty(row.faultReasonId),
        responsibleEntityId: toStrOrEmpty(row.responsibleEntityId),
        responsibilityCode: toStrOrEmpty(row.responsibilityCode),
        responsibleConfirm: toStrOrEmpty(row.responsibleConfirm),
        quesReasonList: Array.isArray(row.quesReasonList) ? row.quesReasonList : [],
        failPointList: Array.isArray(row.failPointList) ? row.failPointList : [],
        solutionList: Array.isArray(row.solutionList) ? row.solutionList : [],
        faultReasonList: Array.isArray(row.faultReasonList) ? row.faultReasonList : [],
        responsibleEntityList: Array.isArray(row.responsibleEntityList) ? row.responsibleEntityList : []
      };
    },
    openDialog() {
      this.$nextTick(() => {
        if (this.type == "maintenQualityInspection") {
          this.$refs.formData.clearValidate();
        }
      });

      this.initData();
    },
    // 初始化数据(获取表头,表格数据)
    async initData() {
      this.dialogLoading = true;
      try {
        let promiseList = [
          findDownList(["INSPECTION_RESPONSIBILITY", "CORRECTIVE_ACTION"]),
          getFaultClassByParent({
            parentId: 0,
            parentFaultType: 0,
            faultType: 1
          }),
          queryInspectionRecord({
            taskInspectionId: this.taskInspectionId
          })
        ];
        let [enumRes, faultRes, recordDetailRes] = await Promise.all(
          promiseList
        );
        //故障责任
        this.responsibilityCodeList = this.getFreezeResponse(enumRes, {
          path: "data.INSPECTION_RESPONSIBILITY",
          freeze: false
        });
        //纠正类型
        this.correctiveActionCodeList = this.getFreezeResponse(enumRes, {
          path: "data.CORRECTIVE_ACTION",
          freeze: false
        });
        this.mainBodyIdList = this.normalizeOptions(this.getFreezeResponse(faultRes, {
          path: "data",
          freeze: false
        }));
        let recordInfoList = recordDetailRes.data.recordInfoList;
        if (recordInfoList.length) {
          // 先规范化 & 设置基础表格数据，避免 v-model 绑定到 null
          const normalizedTable = recordInfoList.map(item => this.sanitizeRow(item));
          this.$set(this.formData, "tableData", normalizedTable);
          
          // 按顺序逐级加载数据，确保前一级加载完成后再加载下一级
          for (let index = 0; index < recordInfoList.length; index++) {
            const item = recordInfoList[index];
            
            // 确保字段存在
            item.responsibilityCode = item.responsibilityCode
              ? item.responsibilityCode * 1
              : "";
            item.responsibleConfirm = item.responsibleConfirm || "";
            
            // 清空后续所有下拉框的选项列表（但不清空选中值，保留查询结果）
            item.quesReasonList = [];
            item.failPointList = [];
            item.solutionList = [];
            item.faultReasonList = [];
            item.responsibleEntityList = [];
            
            // 按顺序加载各级数据
            if (item.mainBodyId) {
              await this.getFaultClassByLevelReq(item.mainBodyId, index, 1, 2, 'quesReasonList');
            }
            
            if (item.quesReasonId) {
              await this.getFaultClassByLevelReq(item.quesReasonId, index, 2, 3, 'failPointList');
            }
            
            if (item.failPointId) {
              await this.getFaultClassByLevelReq(item.failPointId, index, 3, 4, 'solutionList');
            }
            
            if (item.solutionId) {
              await this.getFaultClassByLevelReq(item.solutionId, index, 4, 5, 'faultReasonList');
            }
            
            if (item.faultReasonId) {
              await this.getFaultClassByLevelReq(item.faultReasonId, index, 5, 6, 'responsibleEntityList');
            }
          }
        } else {
          this.formData = {
          tableData: [
            {
              mainBodyId: "",
              quesReasonId: "",
              failPointId: "",
              solutionId: "",
              faultReasonId: "",
              responsibleEntityId: "",
              responsibilityCode: "",
              responsibleConfirm: "",
              quesReasonList: [],
              failPointList: [],
              solutionList: [],
              faultReasonList: [],
              responsibleEntityList: []
            }
          ]
        };
        }

        let {
          isProcessCorrection,
          processCorrection,
          correctiveActionCode,
          fileUrlList,
          inspectionRecordId
        } = recordDetailRes.data;
        this.submitForm = {
          isProcessCorrection: isProcessCorrection ? isProcessCorrection : "",
          processCorrection: processCorrection ? processCorrection : "",
          correctiveActionCode: correctiveActionCode
            ? correctiveActionCode
            : [],
          inspectionRecordId,
          fileList: fileUrlList ? fileUrlList : [],
          fileIdList: fileUrlList ? fileUrlList.map(item => item.fileId) : []
        };
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },

    //修改主体 - 触发6级联动（自动选中并级联加载后续）
    async changeMainbodyId(val, node, index) {
      if (node && node.faultClassId) {
        // 清空后续所有下拉框的值和选项
        let tableData = this.formData.tableData;
        this.$set(tableData[index], 'quesReasonId', "");
        this.$set(tableData[index], 'failPointId', "");
        this.$set(tableData[index], 'solutionId', "");
        this.$set(tableData[index], 'faultReasonId', "");
        this.$set(tableData[index], 'responsibleEntityId', "");
        
        this.$set(tableData[index], 'quesReasonList', []);
        this.$set(tableData[index], 'failPointList', []);
        this.$set(tableData[index], 'solutionList', []);
        this.$set(tableData[index], 'faultReasonList', []);
        this.$set(tableData[index], 'responsibleEntityList', []);
        this.$set(tableData[index], 'responsibleConfirm', "");
        
        this.formData.tableData = tableData;
        
        // 依次获取并自动选中：故障现象(faultType=2)→故障归类(3)→处理措施(4)→故障原因(5)→责任主体(6)
        await this.getFaultClassByLevelReq(node.faultClassId, index, 1, 2, 'quesReasonList', true);
        let parentId = this.formData.tableData[index].quesReasonId;
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 2, 3, 'failPointList', true);
          parentId = this.formData.tableData[index].failPointId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 3, 4, 'solutionList', true);
          parentId = this.formData.tableData[index].solutionId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 4, 5, 'faultReasonList', true);
          parentId = this.formData.tableData[index].faultReasonId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 5, 6, 'responsibleEntityList', true);
        }
      }
    },
    //修改故障现象 - 自动选中并加载后续
    async changeQuesReasonId(val, node, index) {
      if (node && node.faultClassId) {
        // 清空后续下拉框的选项列表（但不清空选中值）
        let tableData = this.formData.tableData;
        this.$set(tableData[index], 'failPointList', []);
        this.$set(tableData[index], 'solutionList', []);
        this.$set(tableData[index], 'faultReasonList', []);
        this.$set(tableData[index], 'responsibleEntityList', []);
        this.$set(tableData[index], 'responsibleConfirm', "");
        this.formData.tableData = tableData;
        
        // 获取故障归类 (faultType=3) 并自动选中，随后继续级联
        await this.getFaultClassByLevelReq(node.faultClassId, index, 2, 3, 'failPointList', true);
        let parentId = this.formData.tableData[index].failPointId;
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 3, 4, 'solutionList', true);
          parentId = this.formData.tableData[index].solutionId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 4, 5, 'faultReasonList', true);
          parentId = this.formData.tableData[index].faultReasonId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 5, 6, 'responsibleEntityList', true);
        }
      }
    },
    //修改故障归类 - 自动选中并加载后续
    async changeFailPointId(val, node, index) {
      if (node && node.faultClassId) {
        // 清空后续下拉框的选项列表（但不清空选中值）
        let tableData = this.formData.tableData;
        this.$set(tableData[index], 'solutionList', []);
        this.$set(tableData[index], 'faultReasonList', []);
        this.$set(tableData[index], 'responsibleEntityList', []);
        this.$set(tableData[index], 'responsibleConfirm', "");
        
        this.formData.tableData = tableData;
        
        // 获取处理措施 (faultType=4) 并自动选中，随后继续级联
        await this.getFaultClassByLevelReq(node.faultClassId, index, 3, 4, 'solutionList', true);
        let parentId = this.formData.tableData[index].solutionId;
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 4, 5, 'faultReasonList', true);
          parentId = this.formData.tableData[index].faultReasonId;
        }
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 5, 6, 'responsibleEntityList', true);
        }
      }
    },
    //修改处理措施 - 自动选中并加载后续
    async changeSolutionId(val, node, index) {
      if (node && node.faultClassId) {
        // 清空后续下拉框的选项列表（但不清空选中值）
        let tableData = this.formData.tableData;
        this.$set(tableData[index], 'faultReasonList', []);
        this.$set(tableData[index], 'responsibleEntityList', []);
        this.$set(tableData[index], 'responsibleConfirm', "");
        
        this.formData.tableData = tableData;
        
        // 获取故障原因 (faultType=5) 并自动选中，随后继续级联
        await this.getFaultClassByLevelReq(node.faultClassId, index, 4, 5, 'faultReasonList', true);
        const parentId = this.formData.tableData[index].faultReasonId;
        if (parentId) {
          await this.getFaultClassByLevelReq(parentId, index, 5, 6, 'responsibleEntityList', true);
        }
      }
    },
    //修改故障原因 - 自动选中并加载后续
    async changeFaultReasonId(val, node, index) {
      // 根据选中的故障原因ID，从故障原因列表中查找对应的customerResponsibility并赋值到responsibleConfirm
      let tableData = this.formData.tableData;
      const faultReasonList = tableData[index].faultReasonList || [];
      const toStr = v => (v === undefined || v === null ? '' : String(v));
      const selectedId = node && node.faultClassId != null ? node.faultClassId : '';
      const selectedReason = faultReasonList.find(item => toStr(item.faultClassId) === toStr(selectedId));
      
      if (selectedReason) {
        this.$set(tableData[index], 'responsibleConfirm', selectedReason.customerResponsibility);
        
        // 确保变更被追踪：替换该行对象（某些场景下第三方表格对深层属性变更不触发）
        tableData.splice(index, 1, Object.assign({}, tableData[index]));
      } else if (node) {
        // 兜底：从回传的节点对象读取
        this.$set(tableData[index], 'responsibleConfirm', node.customerResponsibility);
        tableData.splice(index, 1, Object.assign({}, tableData[index]));
      }
      
      if (node && node.faultClassId) {
        // 清空后续下拉框的选项列表（但不清空选中值）
        this.$set(tableData[index], 'responsibleEntityList', []);
        
        this.formData.tableData = tableData;
        
        // 获取责任主体 (faultType=6) 并自动选中
        await this.getFaultClassByLevelReq(node.faultClassId, index, 5, 6, 'responsibleEntityList', true);
      }
      
      console.log('tableData', tableData[index]);
      
      this.formData.tableData = tableData;
    },
    //修改责任主体 - 最后一级，无需触发后续联动
    changeResponsibleEntityId(val, index) {
      console.log("责任主体选择", val, index);
    },
    //清空主体
    clearMainbodyId(index) {
      let tableData = this.formData.tableData;
      this.$set(tableData[index], 'quesReasonList', []);
      this.$set(tableData[index], 'failPointList', []);
      this.$set(tableData[index], 'solutionList', []);
      this.$set(tableData[index], 'faultReasonList', []);
      this.$set(tableData[index], 'responsibleEntityList', []);
      this.$set(tableData[index], 'quesReasonId', "");
      this.$set(tableData[index], 'failPointId', "");
      this.$set(tableData[index], 'solutionId', "");
      this.$set(tableData[index], 'responsibleEntityId', "");
      this.$set(tableData[index], 'responsibleConfirm', "");
      this.formData.tableData = tableData;
    },
    //获取故障点
    async getFaultClassByParentReq(parentId, index) {
      try {
        let res = await getFaultClassByParent({
          parentId,
          parentFaultType: 1,
          faultType: 3
        });
        if (res.code == "OK") {
          let tableData = this.formData.tableData;
          // 使用$set确保Vue能检测到数组内部对象属性的变化
          this.$set(tableData[index], 'failPointList', this.getFreezeResponse(res, {
            path: "data",
            freeze: false
          }));
          this.formData.tableData = tableData;
        }
      } catch (error) {
        printError(error);
      }
    },
    //通用方法：根据层级获取故障分类数据
    async getFaultClassByLevelReq(parentId, index, parentFaultType, targetFaultType, targetProperty, autoSelect = true) {
      try {
        let res = await getFaultClassByParent({
          parentId,
          parentFaultType: parentFaultType,
          faultType: targetFaultType
        });
        if (res.code == "OK") {
          let tableData = this.formData.tableData;
            const responseDataRaw = this.getFreezeResponse(res, {
            path: "data",
            freeze: false
          });
          const responseData = this.normalizeOptions(responseDataRaw);
          
          // 使用$set确保Vue能检测到数组内部对象属性的变化
          this.$set(tableData[index], targetProperty, responseData);
          
          // 只有在autoSelect为true时才执行自动选中逻辑
          if (autoSelect && responseData.length > 0) {
            let currentId;
            let idProperty;
            
            // 根据targetProperty确定对应的ID属性和当前选中的ID
            switch (targetProperty) {
              case 'quesReasonList':
                idProperty = 'quesReasonId';
                currentId = tableData[index].quesReasonId;
                break;
              case 'failPointList':
                idProperty = 'failPointId';
                currentId = tableData[index].failPointId;
                break;
              case 'solutionList':
                idProperty = 'solutionId';
                currentId = tableData[index].solutionId;
                break;
              case 'faultReasonList':
                idProperty = 'faultReasonId';
                currentId = tableData[index].faultReasonId;
                break;
              case 'responsibleEntityList':
                idProperty = 'responsibleEntityId';
                currentId = tableData[index].responsibleEntityId;
                break;
            }
            
            if (idProperty && currentId) {
              // 检查选中的ID是否存在于新加载的列表中（统一转为字符串比较，避免类型不一致）
              const toStr = v => (v === undefined || v === null ? '' : String(v));
              const selectedOption = responseData.find(item => toStr(item.faultClassId) === toStr(currentId));
              if (selectedOption) {
                // 如果选中的ID存在于新列表中，确保选中状态正确
                this.$set(tableData[index], idProperty, currentId);
                
                // 如果是故障原因列表，还需要设置responsibleConfirm（优先使用customerResponsibility）
                if (targetProperty === 'faultReasonList') {
                  this.$set(tableData[index], 'responsibleConfirm', selectedOption.customerResponsibility || selectedOption.responsibleConfirm || '');
                }
              } else {
                // 如果选中的ID不在新列表中，清空选中值
                this.$set(tableData[index], idProperty, "");
              }
            } else if (idProperty && !currentId) {
              // 如果没有选中的ID，自动选中第一个选项（需保证非空且有 id）
              const firstOption = responseData[0];
              if (firstOption && firstOption.faultClassId != null) {
                this.$set(tableData[index], idProperty, firstOption.faultClassId);
              } else {
                this.$set(tableData[index], idProperty, '');
              }
              
              // 如果是故障原因列表，还需要设置responsibleConfirm（优先使用customerResponsibility）
              if (targetProperty === 'faultReasonList') {
                const confirmVal = firstOption && (firstOption.customerResponsibility || firstOption.responsibleConfirm) || '';
                this.$set(tableData[index], 'responsibleConfirm', confirmVal);
              }
            }
          }
          
          this.formData.tableData = tableData;
        }
      } catch (error) {
        printError(error);
      }
    },
    //点击添加
    handleAdd() {
      let tableData = this.formData.tableData;
      tableData.push({
        mainBodyId: "",
        quesReasonId: "",
        failPointId: "",
        solutionId: "",
        faultReasonId: "",
        responsibleEntityId: "",
        responsibilityCode: "",
        responsibleConfirm: "",
        quesReasonList: [],
        failPointList: [],
        solutionList: [],
        faultReasonList: [],
        responsibleEntityList: []
      });
      this.formData.tableData = tableData;
    },
    //删除单行
    deleteColumn(index) {
      let tableData = _.cloneDeep(this.formData.tableData);
      if (tableData.length == 1) {
        this.$message.warning("至少保留一条数据");
        return;
      }
      tableData.splice(index, 1);
      this.formData.tableData = tableData;
    },
    handleSubmit() {
      if (this.type == "maintenQualityInspection") {
        this.$refs.formData.validate(valid => {
          if (valid) {
            this.dialogLoading = true;
            this.saveReq();
          }
        });
      } else {
        this.dialogLoading = true;
        this.saveReq();
      }
    },
    //保存记录
    async saveReq() {
      let tableRows = _.cloneDeep(this.formData.tableData);
      // 构造提交数据，保证 responsibleConfirm 必有值；必要时临时拉取故障原因列表兜底
      const recordInfoList = [];
      for (let idx = 0; idx < tableRows.length; idx++) {
        const item = tableRows[idx];
        // 从对应的下拉框数据中查找选中的选项，获取对应的name字段
        const findNameFromList = (list, id) => {
          const toStr = v => (v === undefined || v === null ? '' : String(v));
          const found = (list || []).find(option => toStr(option.faultClassId) === toStr(id));
          return found ? found.faultName : "";
        };
        // 兜底：当 item.responsibleConfirm 为空时，从故障原因选项取 customerResponsibility
        const getCustomerResponsibilityFromReason = (id) => {
          const toStr = v => (v === undefined || v === null ? '' : String(v));
          const found = (item.faultReasonList || []).find(option => toStr(option.faultClassId) === toStr(id));
          return found ? found.customerResponsibility : '';
        };
        
        // 从责任类型枚举中查找对应的name
        const findResponsibilityName = (code) => {
          const found = this.responsibilityCodeList.find(option => option.codeId === code);
          return found ? found.codeName : "";
        };
        
        
        const responsibleConfirmFinal = item.responsibleConfirm ? item.responsibleConfirm : getCustomerResponsibilityFromReason(item.faultReasonId);
        // 回写一份，保持与提交一致
        this.$set(this.formData.tableData[idx], 'responsibleConfirm', responsibleConfirmFinal); 
        recordInfoList.push({
          recordInfoId: item.recordInfoId || "",
          responsibilityCode: item.responsibilityCode,
          responsibilityName: findResponsibilityName(item.responsibilityCode) || "",
          mainBodyId: item.mainBodyId,
          mainBodyName: findNameFromList(this.mainBodyIdList || [], item.mainBodyId) || "",
          quesReasonId: item.quesReasonId,
          quesReason: findNameFromList(item.quesReasonList, item.quesReasonId) || "",
          failPointId: item.failPointId,
          failPointName: findNameFromList(item.failPointList, item.failPointId) || "",
          solutionId: item.solutionId,
          solution: findNameFromList(item.solutionList, item.solutionId) || "",
          faultReasonId: item.faultReasonId,
          faultReason: findNameFromList(item.faultReasonList, item.faultReasonId) || "",
          responsibleEntityId: item.responsibleEntityId,
          responsibleEntity: findNameFromList(item.responsibleEntityList, item.responsibleEntityId) || "",
          responsibleConfirm: responsibleConfirmFinal
        });
      }
      // 调试日志：确保提交前每行的 responsibleConfirm 有值（仅开发排查时保留，联调通过后可移除）
      try {
        console.log('saveReq.recordInfoList', recordInfoList);
      } catch (e) {
        printError(e);
      }
      try {
        let res = await saveInspectionRecord({
          recordInfoList:
            this.type == "maintenQualityInspection" ? recordInfoList : [],
          taskInspectionId: this.taskInspectionId,
          ...this.submitForm
        });
        if (res.code == "OK") {
          this.$message.success("保存成功");
          this.$emit("confirm");
          this.closeDialog();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    //关闭弹框
    closeDialog() {
      this.dialogLoading = false;
      this.$emit("update:recordVisible", false);
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
/deep/.audit-dialog {
  .el-dialog__body {
    padding: 15px 20px;
    box-sizing: border-box;
    .inspectionRecordTable {
      .e6-vr-select {
        width: 200px;
      }
      [class^="e6-icon"] {
        height: 28px;
        color: #46bfea;
        line-height: 28px;
        font-style: normal;
        text-align: center;
        padding: 0 10px;
        cursor: pointer;
        border-radius: 3px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 28px;
        padding: 0;
        font-size: 20px;
      }
    }
    // .el-input {
    //   width: 300px;
    // }
  }
}
</style>
